import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Grid,
  Image,
  Segment,
  Header,
  Loader,
  Container
} from 'semantic-ui-react'
import { find, propEq, prop, compose } from 'ramda'
import { UserIsAuthenticated } from 'utils/RouteGuards'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { getRouterCustomerId } from 'store/selectors'
import { dataToJS, firebaseConnect } from 'react-redux-firebase'
import moment from 'moment'
import logo from 'assets/logo_wide.png'
import { genderOptions, manufacturerOptions } from 'utils/Data'
import './styles.scss'

const Spacer = styled.div`
  height: 20px;
`
const FooterText = styled.div`
  font-size: 9px;
`
const SignatureLine = styled.div`
  width: 300px;
  border: 0 solid;
  border-bottom-width: 1px;
`

const Row = ({ data }) => (
  <Grid.Row>
    {data.filter(Boolean).map(({ title, value }, idx) => [
      <Grid.Column key={idx + '0'} textAlign='right'>
        <b>{title}</b>
      </Grid.Column>,
      <Grid.Column key={idx + '1'}>
        <span>{value}</span>
      </Grid.Column>
    ])}
  </Grid.Row>
)

Row.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string
    })
  )
}

const findGender = key =>
  compose(prop('text'), find(propEq('value', key)))(genderOptions)
const findManufacturer = key =>
  compose(prop('text'), find(propEq('value', key)))(manufacturerOptions)
const hasSony = compose(find(propEq('manufacturer', 'sony')))

@UserIsAuthenticated
@firebaseConnect(props => [`customers/${props.location.state.id}`])
@connect(
  // map redux state to props
  state => ({
    customer: dataToJS(
      state.firebase,
      `customers/${getRouterCustomerId(state)}`
    )
  })
)
class Print extends Component {
  static propTypes = {
    customer: PropTypes.object
  }

  state = {
    currentDate: moment()
  }

  print = () => {
    window.print()
  }

  render () {
    const { customer } = this.props

    return customer ? (
      <Container>
        <div style={{ width: '100%', height: 60 }}>
          <Image src={logo} size='small' floated='right' />
        </div>
        <Segment vertical textAlign='center'>
          <Header as='h2' textAlign='center'>
            Registrierungs-Urkunde
          </Header>
          {/* <Header as='h3'>Hersteller: {customer.manufacturer}</Header> */}

          <p>Wir bedanken uns bei Ihnen für den Kauf dieses Produktes.</p>
        </Segment>
        <Spacer />
        <Grid columns={6}>
          <Row data={[{ title: 'Firma', value: customer.company }]} />
          <Row
            data={[
              { title: 'Anrede', value: findGender(customer.title) },
              { title: 'Name', value: customer.name },
              { title: 'Vorname', value: customer.firstName }
            ]}
          />
          <Row
            data={[
              { title: 'Straße', value: customer.street },
              { title: 'PLZ', value: customer.zipCode },
              { title: 'Ort', value: customer.city }
            ]}
          />
          <Row
            data={[{ title: 'E-Mail Adresse', value: customer.email }, {}]}
          />
          <Spacer />
          {customer.products.map((product, index) => (
            <Row
              key={index}
              data={[
                {
                  title: 'Hersteller',
                  value:
                    product.manufacturerOverride ||
                    findManufacturer(product.manufacturer)
                },
                { title: 'Seriennummer', value: product.serial },
                {
                  title: 'Modellzeichnung',
                  value: product.model
                }
              ]}
            />
          ))}
          <Spacer />
          <Row
            data={[
              {
                title: 'Kauf Datum',
                value: moment(customer.purchaseDate).format('D.M.Y')
              },
              { title: 'Verkäufernummer', value: customer.vendorId }
            ]}
          />
        </Grid>
        <Spacer />
        {hasSony(customer.products) && (
          <p>
            Ich bin mit der Weitergabe meiner Daten an Sony Europe Limited zum
            Zweck der kostenlosen Registrierung einverstanden.
          </p>
        )}
        <Spacer />
        {customer.warranty ? (
          <p>Garantie-Erweiterung ausgewählt.</p>
        ) : (
          <p>
            Ich wurde über die Garantieerweiterung informiert und verzichte auf
            den Schutz.
          </p>
        )}
        <Spacer />
        <Header as='b'>
          München, den {this.state.currentDate.format('D.M.Y')}
        </Header>
        <Spacer />
        <Spacer />
        <Spacer />
        <SignatureLine />
        <b>Unterschrift</b>
        <Spacer />
        <Spacer />
        <Grid columns={4}>
          <Grid.Column>
            <FooterText>Hauptgeschäft München</FooterText>
            <FooterText>Sonnenstr. 26</FooterText>
            <FooterText>80331 München</FooterText>
            <FooterText>Telefon (0 89) 55 15 04-50</FooterText>
            <FooterText>Telefax (0 89) 55 15 04-53</FooterText>
            <FooterText>info@foto-video-sauter.de</FooterText>
            <FooterText>www.foto-video-sauter.de</FooterText>
          </Grid.Column>
          <Grid.Column>
            <FooterText>Filiale Rosenheim</FooterText>
            <FooterText>Bahnhofstraße 6</FooterText>
            <FooterText>83022 Rosenheim</FooterText>
            <FooterText>Telefon (0 80 31) 38 17 20</FooterText>
            <FooterText>Telefax (0 80 31) 38 18 20</FooterText>
          </Grid.Column>
          <Grid.Column>
            <FooterText>Commerzbank München</FooterText>
            <FooterText>(BLZ 700 800 00) 3 817 234 00</FooterText>
            <FooterText>SWIFT: DRESDEFF700</FooterText>
            <FooterText>IBAN: DE15700800000381723400</FooterText>
            <FooterText>Postbank München</FooterText>
            <FooterText>(BLZ 700 1 00 80) 420 41 809</FooterText>
            <FooterText>SWIFT: PBNKDEFF</FooterText>
            <FooterText>IBAN: DE23700100800042041809</FooterText>
          </Grid.Column>
          <Grid.Column>
            <FooterText>HR München, HRA 50 078,</FooterText>
            <FooterText>Pers. haft. Gesellschafterin:</FooterText>
            <FooterText>Foto-Video Sauter Verwaltungs GmbH</FooterText>
            <FooterText>HR München, HRB 48 607</FooterText>
            <FooterText>Geschäftsführer: Bernd Sauter</FooterText>
            <FooterText>USt.-ldNr. DE 130486647</FooterText>
            <FooterText>Steuer-Nr. 143/519/40183</FooterText>
          </Grid.Column>
        </Grid>

        <Spacer />
        <Spacer />
        <Button positive fluid className='dont-print' onClick={this.print}>
          Print
        </Button>
        <Spacer />
      </Container>
    ) : (
      <Loader />
    )
  }
}

export default Print



// WEBPACK FOOTER //
// ./src/routes/Print/index.js